import { QUEUE_COUNTS_KEY, fetchQueueCounts } from '@/lib/queueCounts';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import type { OrderQueue } from '@elutide/shared';
import { LIVE } from '@/app/queryClient';
import { Card, EmptyState, ErrorState, Skeleton } from '@/components';

const QUEUES: readonly { id: OrderQueue; label: string }[] = [
  { id: 'needs_attention', label: 'Needs attention' },
  { id: 'awaiting_payment', label: 'Awaiting payment' },
  { id: 'to_print', label: 'To print' },
  { id: 'to_pack', label: 'To pack' },
  { id: 'packed', label: 'Packed' },
  { id: 'in_transit', label: 'In transit' },
  { id: 'exceptions', label: 'Exceptions' },
];

/** One button per queue. Clicking lands in Orders with that queue selected. */
export function QueueButtons() {
  const query = useQuery({
    queryKey: QUEUE_COUNTS_KEY,
    queryFn: fetchQueueCounts,
    ...LIVE,
  });

  return (
    <Card title="Fulfillment queues" id="queues">
      {query.isLoading ? <Skeleton shape="row" lines={2} label="Loading queues" /> : null}
      {query.isError ? (
        <ErrorState message="Queue counts did not load." onRetry={() => void query.refetch()} />
      ) : null}
      {query.data ? (
        <div className="o-row">
          {QUEUES.map((queue) => (
            <Link
              key={queue.id}
              to="/orders"
              search={{ queue: queue.id }}
              className="o-chip"
            >
              <span>{queue.label}</span>
              <span className="o-chip__count">{query.data[queue.id] ?? 0}</span>
            </Link>
          ))}
        </div>
      ) : null}
      {query.data && Object.keys(query.data).length === 0 ? (
        <EmptyState message="No queues reported." />
      ) : null}
    </Card>
  );
}
